import { ProgressBar } from '@sgme/ui';
import { FormattedMessage } from 'components/shared/Intl';
import { useProgressTimer } from 'hooks/useProgressTimer';
import { FC } from 'react';

import type { PendingStatusProps } from './PendingStatus.connect';
import { connectPendingStatus } from './PendingStatus.connect';

const Component: FC<PendingStatusProps> = ({ startingTimeInMillis, durationTimeInMillis }) => {
  const { progressInPercent } = useProgressTimer(startingTimeInMillis, durationTimeInMillis);
  return (
    <>
      <div className="w-100 alert alert-discreet-info d-flex mb-0 px-0 position-relative">
        <div className="card-body">
          <div>
            <strong className="align-middle ms-3">
              <FormattedMessage id="productModification.sidePanel.status.pending" />
            </strong>
          </div>
        </div>
      </div>
      <ProgressBar size="sm" color="info" value={progressInPercent} />
    </>
  );
};
Component.displayName = 'Pending';

export const PendingStatus = connectPendingStatus(Component);
